module.exports = __webpack_public_path__ + "static/screen3-236faca98aa5477d8c93bcd7a15b88db.png";